import { render } from "./ImportChoiceTypeStep.vue?vue&type=template&id=60a89b6f&scoped=true"
import script from "./ImportChoiceTypeStep.vue?vue&type=script&lang=js"
export * from "./ImportChoiceTypeStep.vue?vue&type=script&lang=js"

import "./ImportChoiceTypeStep.vue?vue&type=style&index=0&id=60a89b6f&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a89b6f"]])

export default __exports__